import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { LogOut, User, ShieldCheck, MailWarning } from "lucide-react";
import { useAuth } from "@/lib/auth";

const STATUS = {
  active: { label: "Account attivo", cls: "text-emerald-300", icon: ShieldCheck },
  pending_verification: { label: "Email non verificata", cls: "text-amber-300", icon: MailWarning },
  email_unverified: { label: "Email non verificata", cls: "text-amber-300", icon: MailWarning },
  suspended: { label: "Account sospeso", cls: "text-rose-300", icon: MailWarning },
};

export function AccountMenu() {
  const { user, logout } = useAuth();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const nav = useNavigate();
  useEffect(() => {
    const h = (e) => { if (open && ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, [open]);
  if (!user) return null;
  const st = STATUS[user.status] || STATUS.active;
  return (
    <div className="relative" ref={ref}>
      <button onClick={() => setOpen((o) => !o)} className="w-9 h-9 rounded-lg bg-white/[0.04] border border-white/10 flex items-center justify-center text-slate-200 hover:border-cyan-400/40" data-testid="account-button" title={user.email}>
        <User size={15} />
      </button>
      {open && (
        <div className="absolute right-0 top-full mt-2 w-64 rounded-2xl border border-white/10 bg-[#0F172A]/95 backdrop-blur-xl shadow-2xl p-3 z-40" data-testid="account-panel">
          <div className="text-sm font-semibold text-slate-100 truncate">{user.name}</div>
          <div className="text-xs text-slate-400 truncate" data-testid="account-email">{user.email}</div>
          <div className={`mt-2 text-[11px] font-semibold inline-flex items-center gap-1 ${st.cls}`} data-testid="account-status"><st.icon size={11} /> {st.label}</div>
          <button onClick={async () => { nav("/", { replace: true }); await logout(); toast("Sei uscito da Nadia Cloud"); }} className="mt-3 w-full h-9 rounded-lg border border-white/10 text-sm text-slate-200 hover:text-rose-300 hover:border-rose-400/40 inline-flex items-center justify-center gap-2" data-testid="logout-button">
            <LogOut size={14} /> Esci
          </button>
        </div>
      )}
    </div>
  );
}
